import PropTypes from 'prop-types';
import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';

import Iconify from '../iconify';
import WebhookDeliveriesPanel from './WebhookDeliveriesPanel';

/** CHAN-70: gaveta "Webhooks" aberta a partir da lista de envelopes. */
export default function WebhookDeliveriesDrawer({ open, onClose, envelopeKey, title }) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: '100%', sm: 520 } } }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, pt: 2 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h6">Webhooks</Typography>
          {title ? (
            <Typography variant="caption" color="text.secondary" noWrap>
              {title}
            </Typography>
          ) : null}
        </Box>
        <IconButton onClick={onClose} aria-label="Fechar webhooks">
          <Iconify icon="eva:close-fill" />
        </IconButton>
      </Stack>
      {open && envelopeKey ? <WebhookDeliveriesPanel envelopeKey={envelopeKey} /> : null}
    </Drawer>
  );
}

WebhookDeliveriesDrawer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  envelopeKey: PropTypes.string,
  title: PropTypes.string,
};
